import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { Select, type SelectProps } from '../../../Toolkit/Inputs/Select';
import { preventSubmit } from './preventSubmit';

type FinanceSelectProps = Omit<
  SelectProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceSelect = forwardRef<HTMLSelectElement, FinanceSelectProps>(
  (props, ref) => {
    const { invalid, value, onFocus, ...rest } = props;
    const { clearErrors } = useFormContext();
    return (
      <Select
        {...rest}
        hasError={invalid}
        errorMessage={props.error?.message}
        ref={ref}
        value={value}
        onKeyDown={preventSubmit}
        onFocus={() => {
          clearErrors(props.name);
          onFocus?.();
        }}
      />
    );
  },
);

FinanceSelect.displayName = 'FinanceSelect';
